import { motion } from 'framer-motion';
import { Moon, Sunrise, Sun, Sunset } from 'lucide-react';
import { useTimeOfDayStore } from '../../store/timeOfDayStore.js';

const icons = { sunrise: Sunrise, sun: Sun, sunset: Sunset, moon: Moon } as const;

export default function TimeOfDayBadge() {
  const { phase, label, description, icon, sunrise, sunset } = useTimeOfDayStore();
  const Icon = icons[icon];

  return (
    <motion.div
      layout
      className={`time-badge time-badge-${phase}`}
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      title={`${description}. Sunrise ${sunrise}, sunset ${sunset}.`}
      role="status"
      aria-live="polite"
    >
      <span className="time-badge-icon" aria-hidden="true"><Icon size={15} /></span>
      <span className="hidden sm:block">
        <strong>{label}</strong>
        <small>{description}</small>
      </span>
    </motion.div>
  );
}
